import { createContext } from "react";

type ListboxOptionGroupContextProps = {
  disabled?: boolean;
};

export const ListboxOptionGroupContext =
  createContext<ListboxOptionGroupContextProps>({});
